import Card from './src/card';

export default Card;



// WEBPACK FOOTER //
// ./packages/card/index.js